<template>
  <div class="webeo-wrapper">
    <div class="webeo-container">
      <div class="webeo-header">
        <img src="../assets/webeo-logo.png">
      </div>

      <form class="forgotten-password-controls">
        <div class="inputs">
          <PortalInput
            v-model="form.username"
            label="Username"
            :error="usernameValidation"
            :disabled="!!message"
            data-test="forgotten-password-username"
            @input="$v.form.username.$touch();"
          />
        </div>
        <div
          v-if="!message"
          key="submit"
          class="forgotten-password-actions"
        >
          <button
            data-test="forgotten-password-submit"
            @click="submitForgotPassword(); $event.preventDefault();"
          >
            {{ $t('forgottenPassword.submit').toUpperCase() }}
          </button>
        </div>
        <transition name="fade">
          <div
            v-if="message"
            key="confirmation"
          >
            <div class="forgotten-password-error">
              {{ message }}
            </div>
          </div>
        </transition>
        <div class="forgotten-password-return-action">
          <button
            data-test="forgotten-password-return"
            @click="$router.push('/Login'); $event.preventDefault();"
          >
            {{ $t('forgottenPassword.returnToLogin').toUpperCase() }}
          </button>
        </div>
      </form>
    </div>

    <SupportDetails />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import PortalInput from '../components/PortalInput.vue';
import SupportDetails from '../components/SupportDetails.vue';

export default {
  components: {
    PortalInput,
    SupportDetails,
  },
  data: () => ({
    form: {
      username: null,
    },
    message: null,
  }),
  validations: {
    form: {
      username: {
        required,
      },
    },
  },
  computed: {
    usernameValidation() {
      if (this.$v.form.username.$error && !this.$v.form.username.required) {
        return this.$t('forgottenPassword.validation.username.required');
      }

      return null;
    },
  },
  methods: {
    ...mapActions(['requestPasswordReset']),
    submitForgotPassword() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.requestPasswordReset(this.form.username);
      this.message = this.$t('forgottenPassword.confirmation');
    },
  },
};
</script>
<style scoped>

.webeo-wrapper {
  position: relative;
  top: 5%;
}

.webeo-container {
  width: 650px;
  border: 1px solid var(--webeo-grey100);
  margin:0 auto;
  background-color: var(--webeo-white);
}
.dark-theme .webeo-container {
  border: 1px solid var(--webeo-white);
  background-color: var(--webeo-background-2);
}

.webeo-header {
  padding: 30px 0px 20px 0px;
  display: flex;
  justify-content: center;
}
.webeo-header img {
  width: 200px;
  margin-right: 70px;
}

.inputs {
  margin-top: 20px;
}

.forgotten-password-controls {
  padding: 0px 75px;
}

.forgotten-password-actions {
  position: relative;
}
.forgotten-password-actions button {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  margin-top: 10px;
  border: none;
  background-color: var(--webeo-magenta);
  color: var(--webeo-white);
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
}

.forgotten-password-actions button + button:hover {
  background-color: var(--webeo-grey150);
  border: 1px solid var(--webeo-grey170);
}

.forgotten-password-actions button:hover {
  background-color: var(--webeo-magenta-hover);
}
.forgotten-password-actions button:focus {
  outline: none;
}

.forgotten-password-return-action button {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid var(--webeo-grey100);
  border-radius: 5px;
  color: var(--webeo-black);
  margin-bottom: 20px;
}

.dark-theme .forgotten-password-return-action button {
  background-color: var(--webeo-background-3);
  color: var(--webeo-white);
  border-color: var(--webeo-background-3);
}

.forgotten-password-return-action button:hover {
  background-color: var(--webeo-grey150);
  border: 1px solid var(--webeo-grey170);
};

.forgotten-password-return-action {
  margin-bottom: 25px;
  position: relative;
}

.dark-theme .forgotten-password-return-action button:hover {
  background-color: var(--webeo-accent-background-2) !important;
  border-color: var(--webeo-accent-background-2) !important;
}

.forgotten-password-error {
  background-color: var(--webeo-cyan);
  color: var(--webeo-white);
  margin-bottom: 20px;
  text-align: justify;
  padding: 12px;
  font-size: 13px;
  border-radius: 5px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
